import { ChangeDate } from './ChangeDate';

const initChangeDate = () => {
  new ChangeDate({
    timer: true,
    start: "2025-07-23",
    end: '',
    period: 7,
    selectorCounter: "[data-counter]",
    data: {
      main: {
        total: 94,
        final: 12,
        rate: 6,
      },
      program: {
        total: 94,
        final: 12,
        rate: 6,
      },
    },
  });
};

export default initChangeDate;
